// src/utils.js
import contractABI from './contractABI.json';
import { ethers } from "ethers";

export const CONTRACT_ADDRESS = "0x0C1Fb7B83E6750EA13585E4F2C14aD1C561Db14f";
export const USDT_ADDRESS    = "0x55d398326f99059fF775485246999027B3197955";

export const ADMIN_ADDRESS = "0x3Af93862e0694bd5416D3A62109fB3c9dFadc521";

export const getContract = (signer) => {
  if (!CONTRACT_ADDRESS || CONTRACT_ADDRESS === "0x0") {
    console.error("Contract address is empty or invalid");
    return null;
  }
  return new ethers.Contract(CONTRACT_ADDRESS, contractABI, signer);
};
